import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";
import { Car, MapPin, Clock } from "lucide-react";

export const BookingTypeSelector = ({ bookingType, onBookingTypeChange }) => {
  return (
    <Card className="dashboard-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Car className="h-5 w-5 text-primary" />
          Booking Type
        </CardTitle>
        <CardDescription>Choose between a point-to-point transfer or hourly hire</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4">
          <button
            type="button"
            onClick={() => onBookingTypeChange("transfer")}
            className={`p-6 rounded-xl border-2 transition-all ${
              bookingType === "transfer"
                ? "bg-primary/10 border-primary text-foreground"
                : "bg-secondary/30 border-black/10 text-muted-foreground hover:bg-secondary/50"
            }`}
            data-testid="booking-type-transfer"
          >
            <MapPin className={`h-8 w-8 mx-auto mb-3 ${bookingType === "transfer" ? "text-primary" : ""}`} />
            <p className="font-semibold">Transfer</p>
            <p className="text-xs mt-1 opacity-70">Point A to Point B</p>
          </button>
          <button
            type="button"
            onClick={() => onBookingTypeChange("hourly")}
            className={`p-6 rounded-xl border-2 transition-all ${
              bookingType === "hourly"
                ? "bg-accent/10 border-accent text-foreground"
                : "bg-secondary/30 border-black/10 text-muted-foreground hover:bg-secondary/50"
            }`}
            data-testid="booking-type-hourly"
          >
            <Clock className={`h-8 w-8 mx-auto mb-3 ${bookingType === "hourly" ? "text-accent" : ""}`} />
            <p className="font-semibold">Hourly</p>
            <p className="text-xs mt-1 opacity-70">Hire by the hour</p>
          </button>
        </div>
      </CardContent>
    </Card>
  );
};
